import React from "react";
import { FaArrowLeft, FaRegUserCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { routes } from "../utils/Constants";

const TopBar = ({ title, endBtn, hideBack }) => {
  const navigate = useNavigate();
  return (
    <div className="p-3 bg-slate-600 flex items-center">
      {!hideBack && (
        <FaArrowLeft
          onClick={() => navigate(-1)}
          color="white"
          size={20}
          className="cursor-pointer"
          title="Back"
        />
      )}
      <p className="ml-3 text-white font-bold text-xl">{title}</p>
      <div className="flex-1" />
      {endBtn}
      <FaRegUserCircle
        className="ml-3 cursor-pointer"
        color="white"
        size={25}
        title="View profile"
        onClick={() => navigate(routes.PROFILE)}
      />
    </div>
  );
};

export default TopBar;
